<template>
  <vx-card class="mt-base" title="Law Activity 8 - Civil Case Scenario - Part #2">
    <h4 class="mb-5">The Mediation Process</h4>
    <p class="mb-5">
      This next video outlines the mediation process and explores the pre-trial procedure of
      discovery of documents.
    </p>
    <centered-image-wrapper
      :image="videos[1].image"
      classes="2/3"
      label="Play video: Civil Trial, Episode 2"
      @clicked="showIframePopup(videos[1].video)"
    />
    <p class="mb-5">
      Now, imagine you are a spokesperson for the County Court. The court has been approached by the
      ‘Lawchat’ radio program to explain the benefits of mediation.
    </p>
    <p class="mb-5">
      A member of the public has also contacted Lawchat, arguing that plaintiffs do not get a ‘fair
      outcome’ through mediation and miss out on the chance to have their matter heard in court.
    </p>
    <p class="mb-5">
      The fact sheet Access to Justice and Dispute Resolution provides further information about the
      process and advantages of mediation and alternative dispute resolution generally.
    </p>
    <a target="_blank" :href="'content/law/access-justice-and-dispute-resolution.pdf' | blob_url">
      <centered-image-wrapper
        alt="Access, justice and dispute resolution (PDF) (opens in a new tab)"
        :image="image1"
      />
    </a>
    <h4 class="mb-5">Your Task: Become a Spokesperson</h4>
    <p class="mb-5">
      Once you’ve had a chance to look over the information in the fact sheet, write a short
      role-play monologue that explains the benefits of mediation as well as the possible
      disadvantages. Your script should refer to the principles of justice: fairness, equality, and
      access.
    </p>
    <p class="mb-5">
      You can either type up your speech into the space below, or you can record yourself performing
      it and upload it as an MP3 - or do both!
    </p>
    <p class="mb-5"><strong>Upload an MP3 recording of you performing your script here</strong></p>
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      filetype="audio"
      upload-btn-text="Upload recording"
    />

    <p class="mb-5">and/or</p>
    <p class="mb-5"><strong>Write Your Script Here:</strong></p>
    <textarea-block v-model="data.question1" :editable="isEditable" />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import methods from '@/views/WorkExperiences/components/activity_js/methods';
export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/law/civil_case_part_2_splash.jpg'),
          video: 'https://www.youtube.com/embed/MNUALkdLdSs',
        },
      },
      image1: require('@/assets/images/experiences/law/mediation_fact_sheet_button.jpg'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
